import { BaseClient } from '../client';
import { DealersMock } from './dealer.mocks';
import { TConcessionaria } from './dealer.types';

export const getAllDealers = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return DealersMock;
	// }

	try {
		const response = await BaseClient.get<TConcessionaria[]>(`/Concessionarias`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
